/**
 * The one filter-input look on the Import Detail page. Extracted at the fifth
 * byte-identical copy (iter-1 finding A3): ContactFilterBar's two inputs, the
 * two BCT text filters and the name search all share it — a drifted copy would
 * read as a broken control, not a design choice. `w-full max-w-xs` stays at
 * the call site (only the name search stretches).
 */
export const filterInputClass =
  "rounded-sm border border-border bg-surface px-3 py-1.5 text-body text-text placeholder:text-text-muted focus:border-accent focus:outline-none";
